import type { ReactNode } from "react";

type Color = "gold" | "pink" | "cyan" | "mint";

const BACKGROUNDS: Record<Color, string> = {
  gold: "bg-gold",
  pink: "bg-pink",
  cyan: "bg-cyan",
  mint: "bg-mint",
};

/**
 * The primary action, and the only button shaped like this. Big enough for a
 * five-year-old's finger with a chunky shadow that flattens on press, because
 * the tap needs to feel like it did something.
 *
 * A button says what happens. "Collect my star", not "Submit".
 */
export function BigButton({
  children,
  onClick,
  color = "gold",
  disabled,
}: {
  children: ReactNode;
  onClick: () => void;
  color?: Color;
  disabled?: boolean;
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`kidbtn disp w-full rounded-3xl py-4 text-[21px] ${
        disabled
          ? "bg-cream/15 text-cream/50"
          : `${BACKGROUNDS[color]} text-night shadow-[0_6px_0_rgba(0,0,0,.35)]`
      }`}
    >
      {children}
    </button>
  );
}
